// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ExtendedWindow = Window & { newrelic?: any }

export const newRelicNoticeError = (error: string) => {
  try {
    if (error && (window as ExtendedWindow).newrelic) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
      ;(window as ExtendedWindow).newrelic.noticeError(new Error(error))
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err)
  }
}

export const newRelicAddPageAction = (error: string, dataJson?: Record<string, unknown>) => {
  try {
    if (error && (window as ExtendedWindow).newrelic) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
      ;(window as ExtendedWindow).newrelic.addPageAction(error, dataJson)
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err)
  }
}
